/**
 * Generated by '@kontent-ai/model-generator@6.5.1' at 'Thu, 01 May 2025 19:26:26 GMT'
 *
 * Project name: Benefits Counselor
 * Environment: Production
 * Environment Id: 831b591e-b12f-007a-2617-a35180c56dda
 */
export const contentTypes = {
    /**
     * Action
     */
    action: {
        codename: 'action',
        id: '5f49b360-1f99-4727-a820-9fbbe6db26e4',
        externalId: undefined,
        name: 'Action',
        elements: {
            /**
             * Action name (text)
             *
             * e.g. openMenu
             */
            action_name: {
                codename: 'action_name',
                id: '6eb320ee-5aab-4cac-9d19-10e51b3ee118',
                externalId: undefined,
                name: 'Action name',
                required: false,
                type: 'text'
            },
            /**
             * Argument (text)
             */
            argument: {
                codename: 'argument',
                id: '7a295f44-5bab-4b69-ba02-0f7e131d458b',
                externalId: undefined,
                name: 'Argument',
                required: false,
                type: 'text'
            },
            /**
             * Linked condition (modular_content)
             *
             * Optionally specify a condition that has to be met to take the action above
             */
            condition: {
                codename: 'condition',
                id: '6856fb62-98ec-4386-8dfc-da2d42b753d2',
                externalId: undefined,
                name: 'Linked condition',
                required: false,
                type: 'modular_content'
            }
        }
    },
    /**
     * Audio
     */
    audio: {
        codename: 'audio',
        id: 'e1c97175-9141-4a00-8201-f3b5d409df62',
        externalId: undefined,
        name: 'Audio',
        elements: {
            /**
             * Audio file (asset)
             */
            audio_file: {
                codename: 'audio_file',
                id: 'cbf50941-f431-481c-b63a-9fc6b38c6221',
                externalId: undefined,
                name: 'Audio file',
                required: true,
                type: 'asset'
            },
            /**
             * Closed caption (asset)
             */
            cc: {
                codename: 'cc',
                id: '67e1b293-ffc2-423a-9e2d-48bbebcce330',
                externalId: undefined,
                name: 'Closed caption',
                required: true,
                type: 'asset'
            }
        }
    },
    /**
     * Condition
     */
    condition: {
        codename: 'condition',
        id: '8d7ce796-17a8-4484-9953-23cf25d9faff',
        externalId: undefined,
        name: 'Condition',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '2a756cc2-0f87-45ca-8236-97d45d59fac5',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            }
        }
    },
    /**
     * Conditional Rich Text
     */
    conditional_rich_text: {
        codename: 'conditional_rich_text',
        id: '38f10528-23fe-4610-b2bf-341058c5c244',
        externalId: undefined,
        name: 'Conditional Rich Text',
        elements: {
            /**
             * Condition (modular_content)
             */
            condition: {
                codename: 'condition',
                id: '6c19c71b-46c0-4ff4-a8c5-ad9150513d12',
                externalId: undefined,
                name: 'Condition',
                required: false,
                type: 'modular_content'
            },
            /**
             * Content (rich_text)
             *
             * See guidelines for more info & specifics.
             */
            content: {
                codename: 'content',
                id: '77ef3b15-dfb0-44d8-88a8-85d43be57ac8',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            }
        }
    },
    /**
     * Custom Video Explainer Page
     */
    custom_video_explainer_page: {
        codename: 'custom_video_explainer_page',
        id: 'bf685c2d-6727-4d04-939d-933efd14230b',
        externalId: undefined,
        name: 'Custom Video Explainer Page',
        elements: {
            /**
             * Closed Caption (asset)
             *
             * Closed captions to show with the MP4 file.
             */
            cc: {
                codename: 'cc',
                id: 'e6d985e4-4815-4212-ac02-f0bf4e903140',
                externalId: undefined,
                name: 'Closed Caption',
                required: false,
                type: 'asset'
            },
            /**
             * Dynamic text (asset)
             *
             * A VTT file used to display dynamic text on top of the video file.
             */
            dynamic_text: {
                codename: 'dynamic_text',
                id: '95ba0ace-e028-471c-abe2-e7ca9b5cb201',
                externalId: undefined,
                name: 'Dynamic text',
                required: false,
                type: 'asset'
            },
            /**
             * MP4 File (asset)
             */
            mp4_file: {
                codename: 'mp4_file',
                id: 'a0ce3295-1d50-4ffa-b6e9-ea5ff0a72fc4',
                externalId: undefined,
                name: 'MP4 File',
                required: false,
                type: 'asset'
            },
            /**
             * Page Customized (modular_content)
             *
             * Select the page that will be getting customized.
             */
            page_customized: {
                codename: 'page_customized',
                id: 'ee458c9c-dcba-4580-803d-770072db1c0b',
                externalId: undefined,
                name: 'Page Customized',
                required: true,
                type: 'modular_content'
            }
        }
    },
    /**
     * Custom Video Explainer Page  copy
     */
    custom_video_explainer_page__copy_: {
        codename: 'custom_video_explainer_page__copy_',
        id: 'ee69cd2f-9d04-49cc-a7b3-549bb569a416',
        externalId: undefined,
        name: 'Custom Video Explainer Page (copy)',
        elements: {
            /**
             * Closed Caption (asset)
             *
             * Closed captions to show with the MP4 file.
             */
            cc: {
                codename: 'cc',
                id: '37218cda-1c2b-4621-91e6-c9b198349d37',
                externalId: undefined,
                name: 'Closed Caption',
                required: false,
                type: 'asset'
            },
            /**
             * Dynamic text (asset)
             *
             * A VTT file used to display dynamic text on top of the video file.
             */
            dynamic_text: {
                codename: 'dynamic_text',
                id: '7275de36-5466-40a1-84f7-2fc067363c86',
                externalId: undefined,
                name: 'Dynamic text',
                required: false,
                type: 'asset'
            },
            /**
             * MP4 File (asset)
             */
            mp4_file: {
                codename: 'mp4_file',
                id: '20ef18c3-1748-420e-a113-a8161ac511d2',
                externalId: undefined,
                name: 'MP4 File',
                required: false,
                type: 'asset'
            },
            /**
             * Page Customized (modular_content)
             *
             * Select the page that will be getting customized.
             */
            page_customized: {
                codename: 'page_customized',
                id: '0a621b27-5923-48e4-b217-da668d3e9144',
                externalId: undefined,
                name: 'Page Customized',
                required: true,
                type: 'modular_content'
            }
        }
    },
    /**
     * Customer
     */
    customer: {
        codename: 'customer',
        id: '10093938-ed01-49d2-95c9-0cd56ddb6d08',
        externalId: undefined,
        name: 'Customer',
        elements: {
            /**
             * Custom Pages (modular_content)
             *
             * Custom pages get associated to this customer here
             */
            custom_pages: {
                codename: 'custom_pages',
                id: 'db6e10d7-a9e9-4544-a2e2-b710354deca5',
                externalId: undefined,
                name: 'Custom Pages',
                required: false,
                type: 'modular_content'
            },
            /**
             * Customer Key (text)
             *
             * This needs to match the customer key in the BC URL.
             */
            customer_key: {
                codename: 'customer_key',
                id: '5a22594a-d0f4-4a22-b1f4-b75511221a30',
                externalId: undefined,
                name: 'Customer Key',
                required: true,
                type: 'text'
            }
        }
    },
    /**
     * Details Page
     */
    details_page: {
        codename: 'details_page',
        id: 'f39f6e00-4f53-4370-b5c7-8374ca33793b',
        externalId: undefined,
        name: 'Details Page',
        elements: {
            /**
             * Choices (modular_content)
             */
            choices: {
                codename: 'choices',
                id: '8f5c8c29-2d85-4779-9235-7aaba2041d0e',
                externalId: undefined,
                name: 'Choices',
                required: false,
                type: 'modular_content'
            },
            /**
             * Content (modular_content)
             */
            content: {
                codename: 'content',
                id: '170d34fc-4886-470f-866b-470a9a363f5a',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'modular_content'
            },
            /**
             * Question (text)
             */
            question: {
                codename: 'question',
                id: '54cd56f8-1388-4d22-844e-02fee4d2244a',
                externalId: undefined,
                name: 'Question',
                required: false,
                type: 'text'
            }
        }
    },
    /**
     * Details Page Content
     */
    details_page_content: {
        codename: 'details_page_content',
        id: 'de12a09f-0688-4169-9d6f-e1cc37bdbc8b',
        externalId: undefined,
        name: 'Details Page Content',
        elements: {
            /**
             * Condition (modular_content)
             */
            condition: {
                codename: 'condition',
                id: 'f2fb9f98-21cf-4400-84ea-811a0aa96d61',
                externalId: undefined,
                name: 'Condition',
                required: false,
                type: 'modular_content'
            },
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '3ba0e9f1-8328-4fc0-95b1-856c3b89b7fe',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            }
        }
    },
    /**
     * Input choice
     */
    input_choice: {
        codename: 'input_choice',
        id: '4352001f-07e2-495d-b50e-88c0ef8bb140',
        externalId: undefined,
        name: 'Input choice',
        elements: {
            /**
             * Condition (modular_content)
             */
            condition: {
                codename: 'condition',
                id: 'aa7956fb-ac12-4c25-b3ca-28dc515970e0',
                externalId: undefined,
                name: 'Condition',
                required: false,
                type: 'modular_content'
            },
            /**
             * Input text (text)
             */
            input_text: {
                codename: 'input_text',
                id: '1c3b3e4a-0bec-4c28-9f2d-6ad0397c427a',
                externalId: undefined,
                name: 'Input text',
                required: true,
                type: 'text'
            },
            /**
             * Linked action (modular_content)
             */
            linked_action: {
                codename: 'linked_action',
                id: 'bac62203-0e2d-44c0-a3a7-2080ab09d65f',
                externalId: undefined,
                name: 'Linked action',
                required: false,
                type: 'modular_content'
            },
            /**
             * Linked destinations (modular_content)
             */
            linked_destinations: {
                codename: 'linked_destinations',
                id: '559d24af-c931-4ae1-979b-2326ddced906',
                externalId: undefined,
                name: 'Linked destinations',
                required: false,
                type: 'modular_content'
            },
            /**
             * Response audio (modular_content)
             */
            response_audio: {
                codename: 'response_audio',
                id: '83bb0a55-0209-40c0-b630-bfc660350a20',
                externalId: undefined,
                name: 'Response audio',
                required: false,
                type: 'modular_content'
            },
            /**
             * Set User State (modular_content)
             */
            linked_set_user_state: {
                codename: 'linked_set_user_state',
                id: '9fb9a164-c89a-4b99-ab4f-644f993ccb67',
                externalId: undefined,
                name: 'Set User State',
                required: false,
                type: 'modular_content'
            }
        }
    },
    /**
     * Path
     */
    path: {
        codename: 'path',
        id: '00e19205-410e-4f60-9567-948c310088c7',
        externalId: undefined,
        name: 'Path',
        elements: {
            /**
             * Condition (modular_content)
             */
            condition: {
                codename: 'condition',
                id: '61f76af1-69a4-4f0b-99f7-fdf24e976d1b',
                externalId: undefined,
                name: 'Condition',
                required: false,
                type: 'modular_content'
            },
            /**
             * Destination (modular_content)
             */
            destination: {
                codename: 'destination',
                id: 'b614e76c-0a8a-4d01-9769-6f5f78382c3d',
                externalId: undefined,
                name: 'Destination',
                required: false,
                type: 'modular_content'
            }
        }
    },
    /**
     * Path Group
     */
    path_group: {
        codename: 'path_group',
        id: 'ca739a55-f282-4d4b-a661-bc155dabd72d',
        externalId: undefined,
        name: 'Path Group',
        elements: {
            /**
             * Paths (modular_content)
             */
            paths: {
                codename: 'paths',
                id: 'c4aeea7c-7cde-4038-b340-3579768cabfc',
                externalId: undefined,
                name: 'Paths',
                required: false,
                type: 'modular_content'
            }
        }
    },
    /**
     * Question
     */
    question: {
        codename: 'question',
        id: '90e5f3ea-c4c9-43c2-9976-1416c2d665c3',
        externalId: undefined,
        name: 'Question',
        elements: {
            /**
             * Question text (text)
             */
            question_text: {
                codename: 'question_text',
                id: '2c2f9ec5-4840-443d-9f84-c3be4c3acfb7',
                externalId: undefined,
                name: 'Question text',
                required: true,
                type: 'text'
            }
        }
    },
    /**
     * Set User State
     */
    set_user_state: {
        codename: 'set_user_state',
        id: '75c2adff-bd5d-4f91-98fc-f1fb4d11166d',
        externalId: undefined,
        name: 'Set User State',
        elements: {
            /**
             * Value (text)
             *
             *
             */
            value: {
                codename: 'value',
                id: '96addf7c-7926-404b-a3aa-5038924e092f',
                externalId: undefined,
                name: 'Value',
                required: true,
                type: 'text'
            },
            /**
             * Variable (text)
             *
             *
             */
            variable: {
                codename: 'variable',
                id: '5e447721-beca-4fdb-b228-c2f110532ce6',
                externalId: undefined,
                name: 'Variable',
                required: true,
                type: 'text'
            }
        }
    },
    /**
     * Single question page
     */
    single_question_page: {
        codename: 'single_question_page',
        id: '98326278-e70f-45ca-94f8-02feef291b9a',
        externalId: undefined,
        name: 'Single question page',
        elements: {
            /**
             * Choices (modular_content)
             *
             * Select the possible choices for this page
             */
            choices: {
                codename: 'choices',
                id: 'ed4521b3-c033-4755-a88f-b7d667109a7a',
                externalId: undefined,
                name: 'Choices',
                required: true,
                type: 'modular_content'
            },
            /**
             * Explanation text (rich_text)
             *
             * Optional explanation text. Note that this will only render in the 66/33 page layout. See guidelines at the end for more info.
             */
            explanation_text: {
                codename: 'explanation_text',
                id: '1d726093-f0d8-483b-b997-0f712240ab71',
                externalId: undefined,
                name: 'Explanation text',
                required: false,
                type: 'rich_text'
            },
            /**
             * Module (taxonomy)
             */
            module: {
                codename: 'module',
                id: '04cb3e53-5646-4814-bf8a-5fded0ae5741',
                externalId: undefined,
                name: 'Module',
                required: false,
                type: 'taxonomy'
            },
            /**
             * Page layout (multiple_choice)
             *
             * Use this to set the layout of the page
             */
            page_layout: {
                codename: 'page_layout',
                id: '168ab969-3ea9-4df8-9f9f-f28b2064ac2f',
                externalId: undefined,
                name: 'Page layout',
                required: true,
                type: 'multiple_choice',
                options: {
                    two_column_66_33: {
                        name: 'Two column 66 33',
                        id: 'a1039f7d-dd1c-49ea-a4d6-ed053c2fc65a',
                        codename: 'two_column_66_33',
                        externalId: undefined
                    },
                    single_column_half_width: {
                        name: 'Single column half width',
                        id: '3c93d243-abb1-4014-b4ec-b14fded2f3f5',
                        codename: 'single_column_half_width',
                        externalId: undefined
                    }
                }
            },
            /**
             * Question (modular_content)
             *
             * Select the question for this page
             */
            question: {
                codename: 'question',
                id: '72adc2a5-864e-4d78-ac63-a1d157763c93',
                externalId: undefined,
                name: 'Question',
                required: true,
                type: 'modular_content'
            },
            /**
             * Question audio (modular_content)
             *
             * This is the audio file that will narrate the onscreen question
             */
            question_audio: {
                codename: 'question_audio',
                id: '69601b5a-77cd-413f-9ec8-68a4559aa221',
                externalId: undefined,
                name: 'Question audio',
                required: true,
                type: 'modular_content'
            },
            /**
             * Question clarification (rich_text)
             *
             * Add additional clarification text for the question here. See guidelines at the end for more info.
             */
            subhead: {
                codename: 'subhead',
                id: '722e0f15-0b0e-434d-9fae-a19b7415f710',
                externalId: undefined,
                name: 'Question clarification',
                required: false,
                type: 'rich_text'
            },
            /**
             * Section Header (text)
             *
             * Optional moment section header
             */
            section_header: {
                codename: 'section_header',
                id: '85bc7e12-ad23-4c4d-b6b9-b41a38d3d817',
                externalId: undefined,
                name: 'Section Header',
                required: false,
                type: 'text'
            },
            /**
             * Text Note (modular_content)
             */
            linked_text_note: {
                codename: 'linked_text_note',
                id: '2662ab0b-2abd-4a07-b5ad-4267cb0bc66d',
                externalId: undefined,
                name: 'Text Note',
                required: false,
                type: 'modular_content'
            }
        }
    },
    /**
     * Text Note
     */
    text_note: {
        codename: 'text_note',
        id: '3a47feb9-e5cc-49ab-95cd-10c9668d0c47',
        externalId: undefined,
        name: 'Text Note',
        elements: {
            /**
             * Full Text Key (text)
             *
             * Enter the key name of the full text variable from the plan data. E.g. if the full text lives at medPlan.medNoteFullText, you would put medNoteFullText here.
             */
            full_text_key: {
                codename: 'full_text_key',
                id: 'efc9c98b-e7f0-46f2-9c7c-fae3f7271b07',
                externalId: undefined,
                name: 'Full Text Key',
                required: false,
                type: 'text'
            },
            /**
             * Short Note Key (text)
             *
             * Enter the key name of the short note variable from the plan data. E.g. if the short lives at medPlan.medShortNote, you would put medShortNote here.
             */
            short_note_key: {
                codename: 'short_note_key',
                id: 'dab43e64-8a43-46cd-95ad-80cab13e5a59',
                externalId: undefined,
                name: 'Short Note Key',
                required: true,
                type: 'text'
            }
        }
    },
    /**
     * Video Explainer Page
     */
    video_explainer_page: {
        codename: 'video_explainer_page',
        id: '141ab070-027a-429d-8c04-f9315f70b088',
        externalId: undefined,
        name: 'Video Explainer Page',
        elements: {
            /**
             * Closed Caption (asset)
             */
            cc: {
                codename: 'cc',
                id: '79c87862-b456-4dcd-8f30-01b8453abf7b',
                externalId: undefined,
                name: 'Closed Caption',
                required: false,
                type: 'asset'
            },
            /**
             * Dynamic text (asset)
             *
             * A VTT file used to display dynamic text on top of the video file.
             */
            dynamic_text: {
                codename: 'dynamic_text',
                id: '3a84caba-f3a3-4595-8b71-58fe7f7ef988',
                externalId: undefined,
                name: 'Dynamic text',
                required: false,
                type: 'asset'
            },
            /**
             * Linked destinations (modular_content)
             */
            linked_destinations: {
                codename: 'linked_destinations',
                id: '0790e8bb-45b5-4ace-ad82-2973cf86d357',
                externalId: undefined,
                name: 'Linked destinations',
                required: false,
                type: 'modular_content'
            },
            /**
             * Module (taxonomy)
             */
            module: {
                codename: 'module',
                id: '16306178-2745-44d9-83c7-ec4e2e6726b3',
                externalId: undefined,
                name: 'Module',
                required: false,
                type: 'taxonomy'
            },
            /**
             * MP4 File (asset)
             */
            mp4_file: {
                codename: 'mp4_file',
                id: '385d0a69-cbea-4402-a018-48f7191abda7',
                externalId: undefined,
                name: 'MP4 File',
                required: true,
                type: 'asset'
            }
        }
    }
};
//# sourceMappingURL=contentTypes.js.map